import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
export function PrivacyPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900 flex flex-col" data-id="element-375">
      {/* Header */}
      <header className="border-b border-gray-100 py-4 px-4 sticky top-0 bg-white/90 backdrop-blur-sm z-10" data-id="element-376">
        <div className="max-w-3xl mx-auto flex items-center justify-between" data-id="element-377">
          <a href="#" className="flex items-center gap-2 text-sm text-gray-500 hover:text-rose-600 transition-colors" data-id="element-378">
            <ArrowLeft className="h-4 w-4" data-id="element-379" />
            Volver al inicio
          </a>
          <span className="font-bold text-gray-900" data-id="element-380">
            Di Esto, <span className="text-rose-600" data-id="element-381">No Aquello™</span>
          </span>
        </div>
      </header>

      <main className="flex-grow px-4 py-12" data-id="element-382">
        <div className="max-w-3xl mx-auto prose prose-rose prose-headings:font-bold prose-a:text-rose-600" data-id="element-383">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-384">
            Política de Privacidad
          </h1>
          <p className="text-sm text-gray-500 mb-8" data-id="element-385">
            Última actualización: Febrero 2026
          </p>

          <h3 data-id="element-386">1. Información que Recopilamos</h3>
          <p data-id="element-387">
            Respetamos tu privacidad y nos comprometemos a proteger tus datos
            personales. Cuando visitas nuestro sitio o realizas una compra,
            podemos recopilar la siguiente información:
          </p>
          <ul data-id="element-388">
            <li data-id="element-389">
              <strong data-id="element-390">Información personal:</strong> Nombre, dirección de correo
              electrónico y número de teléfono (proporcionados al realizar la
              compra).
            </li>
            <li data-id="element-391">
              <strong data-id="element-392">Información de pago:</strong> Procesada de forma segura
              por Hotmart (no almacenamos tus datos financieros).
            </li>
            <li data-id="element-393">
              <strong data-id="element-394">Datos de uso:</strong> Información sobre cómo interactúas
              con nuestro sitio web (mediante cookies y tecnologías similares).
            </li>
          </ul>

          <h3 data-id="element-395">2. Uso de la Información</h3>
          <p data-id="element-396">Utilizamos tu información para:</p>
          <ul data-id="element-397">
            <li data-id="element-398">Procesar tu pedido y entregar el producto digital.</li>
            <li data-id="element-399">
              Enviarte correos electrónicos relacionados con tu compra
              (confirmación, acceso, actualizaciones).
            </li>
            <li data-id="element-400">Responder a tus consultas de soporte.</li>
            <li data-id="element-401">Mejorar nuestro sitio web y servicios.</li>
            <li data-id="element-402">Cumplir con obligaciones legales.</li>
          </ul>

          <h3 data-id="element-403">3. Hotmart como Procesador de Pagos</h3>
          <p data-id="element-404">
            Utilizamos la plataforma <strong data-id="element-405">Hotmart</strong> para procesar
            todos los pagos y entregar el producto digital. Hotmart tiene su
            propia política de privacidad y medidas de seguridad para proteger
            tus datos financieros. Al comprar, tus datos son compartidos con
            Hotmart para completar la transacción.
          </p>

          <h3 data-id="element-406">4. Cookies y Tecnologías de Rastreo</h3>
          <p data-id="element-407">
            Utilizamos cookies para mejorar tu experiencia en nuestro sitio.
            También podemos utilizar píxeles de terceros (como el Meta Pixel)
            para medir la efectividad de nuestra publicidad y mostrar anuncios
            relevantes. Puedes configurar tu navegador para rechazar cookies,
            aunque esto podría afectar algunas funcionalidades del sitio.
          </p>

          <h3 data-id="element-408">5. Compartir Información con Terceros</h3>
          <p data-id="element-409">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros para fines comerciales, excepto con proveedores de
            servicios necesarios para nuestra operación (como Hotmart para pagos
            o servicios de email marketing para enviarte el producto).
          </p>

          <h3 data-id="element-410">6. Seguridad de los Datos</h3>
          <p data-id="element-411">
            Implementamos medidas de seguridad razonables para proteger tu
            información personal contra acceso no autorizado, alteración o
            divulgación. Sin embargo, ninguna transmisión por internet es 100%
            segura.
          </p>

          <h3 data-id="element-412">7. Tus Derechos</h3>
          <p data-id="element-413">
            Tienes derecho a acceder, corregir o eliminar tu información
            personal que tenemos almacenada. Para ejercer estos derechos,
            contáctanos a nuestro correo electrónico.
          </p>

          <h3 data-id="element-414">8. Cambios a esta Política</h3>
          <p data-id="element-415">
            Podemos actualizar esta política de privacidad ocasionalmente. Te
            notificaremos sobre cambios significativos publicando la nueva
            política en esta página.
          </p>

          <h3 data-id="element-416">9. Contacto</h3>
          <p data-id="element-417">
            Si tienes preguntas sobre nuestra política de privacidad,
            contáctanos en:{' '}
            <a href="mailto:amorconprincipios.info@gmail.com" data-id="element-418">
              amorconprincipios.info@gmail.com
            </a>
            .
          </p>
        </div>
      </main>

      <Footer data-id="element-419" />
    </div>;
}